/* esm.sh - d3-transition@3.0.1/src/transition/easeVarying */
export * from "/*d3-transition@3.0.1/esnext/src/transition/easeVarying.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/easeVarying.mjs";
